import UserThumbnail from '@atom/components/common/UserThumbnail';

import classes from './userTile.module.css';

interface Props {
  user: any;
}

const EditTaskUserTile = ({ user }: Props) => {
  const fullName = `${user.firstName} ${user.lastName}`;
  return (
    <>
      <div className={classes.userContainer}>
        <div className={classes.userContentContainer}>
          <UserThumbnail
            taskUserStatus={user.status}
            image={user.photoUrl}
            alt={fullName}
          />
          <div className={classes.userDetails}>
            <div className={classes.name}>{fullName}</div>
            <div className={classes.email}>{user.email}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditTaskUserTile;
